<template>
    <div>
        <el-form v-loading='loading' :model="formValue" ref="formValue" :rules="rules" label-width="100px" class="" >
            <el-row>
                <el-col :span="8" :offset='1'>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="formValue.name" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8" :offset='4'>
                    <el-form-item label="工作单位" prop="company">
                        <el-input v-model="formValue.company"></el-input>
                    </el-form-item>
                </el-col>
                
            </el-row>
            <el-row>
                <el-col :span="8" :offset='1'>
                    <el-form-item label="手机号码" prop="phone">
                        <el-input v-model="formValue.phone" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10" :offset='4'>
                    <el-form-item label="单位地址" prop="city">
                        <!-- <el-input v-model="formValue.address"></el-input> -->
                        <city @addlist="getCity" :addrVal='formValue'></city>    
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8" :offset='1'>
                    <el-form-item label="身份证号" prop="idcard">
                        <el-input v-model="formValue.idcard" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8" :offset='4'>
                    <el-form-item label="最高学历" prop="education">
                        <el-select v-model="formValue.education" placeholder="请选择" >
                            <el-option v-for="item in educationList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                

            </el-row>
            <el-row>
                <el-col :span="8" :offset='1'>
                    <el-form-item label="性别" prop="sex">
                        <el-select v-model="formValue.sex" placeholder="请选择">
                            <el-option v-for="item in sexList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8" :offset='4'>
                    <el-form-item label="专业" prop="major">
                        <el-input v-model="formValue.major"></el-input>
                    </el-form-item>
                </el-col>
               

            </el-row>
            <el-row>
                <el-col :span="8" :offset='1'>
                    <el-form-item label="执证类型" prop="certification_type">
                        <el-select v-model="formValue.certification_type"  placeholder="请选择" disabled>
                            <el-option v-for="item in certification_typeList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8" :offset='4'>
                    <el-form-item label="毕业院校" prop="graduate_school">
                        <el-input v-model="formValue.graduate_school"></el-input>
                    </el-form-item>
                </el-col>
                
            </el-row>
            <el-row>
                <el-col :span="8" :offset='1'>
                    <el-form-item label="资格证号1" prop="certification_number1">
                        <el-input v-model="formValue.certification_number1"></el-input>
                    </el-form-item>
                </el-col>
                 <el-col :span="8" :offset='4'>
                    <el-form-item label="民族"  prop="ethnic">
                        <el-select v-model="formValue.ethnic" placeholder="请选择">
                            <el-option v-for="item in ethnicList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                
            </el-row>
            <el-row>
                

                <el-col :span="8" :offset='1'>
                    <el-form-item label="资格证号2" prop="certification_number2">
                        <el-input v-model="formValue.certification_number2"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8" :offset='4'>
                    <el-form-item label="职称"  prop="profession_ranks">
                        <el-select v-model="formValue.profession_ranks" placeholder="请选择">
                            <el-option v-for="item in profession_ranksList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="8" :offset='1'>
                    <el-form-item label="电子邮箱" prop="email">
                        <el-input v-model="formValue.email"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8" :offset='4'>
                    <el-form-item label="政治面貌" prop="politics_status">
                        <el-select v-model="formValue.politics_status" placeholder="请选择">
                            <el-option v-for="item in politics_statusList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row>
                <el-col class="btnBox">
                    <el-button class="btn" type="primary" :loading="saveLoading" @click="submitForm">保存更改</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
import customValidate from '../../../assets/js/customValidate.js';
import city from '../../common/city';

export default {
    name: 'studentInfo',
    components: {
        city
    },
    
    data () {
        return {
            loading:true,
            saveLoading:false,
            formValue: {
            },
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                education: [
                    { required: true, message: '请选择学历', trigger: 'blur' },
                ],
                sex: [
                    { required: true, message: '请选择性别', trigger: 'blur' },
                ],
                phone: [
                    { required: true, validator: customValidate.checkPhone, trigger: 'blur' },
                ],
                major: [
                    { required: true, message: '请输入专业', trigger: 'blur' },
                ],
                idcard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                    { validator: customValidate.idCard, trigger: 'blur' },
                ],
                certification_type: [
                    { required: true, message: '请选择执证类型', trigger: 'blur' },
                ],
                ethnic: [
                    { required: true, message: '请选择民族', trigger: 'blur' },
                ],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { email: true, message: '格式不正确', trigger: 'blur' },
                ],
                profession_ranks: [
                    { required: true, message: '请选择职称', trigger: 'blur' },
                ],
                politics_status: [
                    { required: true, message: '请选择政治面貌', trigger: 'blur' },
                ],
                certification_number1:[
                    { required: true, message: '请输入资格证号1', trigger: 'blur' }
                ],
                certification_number2:[
                    // { required: true, message: '请输入资格证号2', trigger: 'blur' }
                ],
                company: [
                    { required: true, message: '请输入工作单位', trigger: 'blur' },
                    { pattern: /^[\u4E00-\u9FA5]+$/, message: '工作单位只能为中文'}
                ],
                graduate_school: [
                    { required: true, message: '请输入毕业院校', trigger: 'blur' },
                ],
                city: [
                    { required: true, message: '请选择单位地址', trigger: 'blur' },
                ],
            },
            educationList: [{
                value: 1,
                label: '高中'
            }, {
                value: 2,
                label: '中专'
            }, {
                value: 3,
                label: '大专'
            }, {
                value: 4,
                label: '本科'
            }, {
                value: 5,
                label: '研究生'
            }],
            certification_typeList: [{
                value: 1,
                label: '西药执业药师'
            }, {
                value: 2,
                label: '中药执业药师'
            }, {
                value: 3,
                label: '双证执业药师'
            }, {
                value: 4,
                label: '从业药师'
            }],
            ethnicList: [{
                value: 1,
                label: '汉族'
            }, {
                value: 2,
                label: '少数民族'
            }],
            profession_ranksList: [{
                value: 0,
                label: '无职称'
            }, {
                value: 1,
                label: '初级'
            }, {
                value: 2,
                label: '中级'
            }, {
                value: 3,
                label: '高级'
            }],
            politics_statusList: [{
                value: 1,
                label: '团员'
            }, {
                value: 2,
                label: '党员'
            }, {
                value: 3,
                label: '群众'
            }],
            sexList:[
                {
                    value:1,
                    label:'男'
                },
                {
                    value:2,
                    label:'女'
                },
                {
                    value:3,
                    label:'保密'
                },
            ]
        }
    },
    mounted(){
        
        this.$store.dispatch('getProfile').then((res)=>{
            this.formValue =  res.data ? res.data : {};
            this.loading = false;
        }).catch((error)=>{
            this.loading = false;
            console.log('错误信息：', error)
        });
      
    },
    methods: {
        getCity(city){
            this.formValue.city_id = city['3'].city;
            this.formValue.province_id = city['3'].provinceid;
            this.formValue.area_id = city['3'].area;
            this.formValue.company_address = city[0] + '-' + city[1] + '-' + city[2];
        },
        submitForm () {
            // console.log(this.formValue)
            if( this.formValue.area_id ){
                this.formValue.city = '1';
            }

            console.log(this.formValue);

            // return false;
            this.$refs['formValue'].validate((valid) => {
                if (valid) {
                    if( this.formValue.company_address ){
                        this.formValue['province'] = this.formValue.company_address.split('-')[0];
                        this.formValue['city'] = this.formValue.company_address.split('-')[1];
                        this.formValue['county'] = this.formValue.company_address.split('-')[2];
                    }
                    delete this.formValue.company_address;
                    // delete this.formValue.city;


                    this.saveLoading = true;
                    this.$store.dispatch('setModify',this.formValue).then((res)=>{
                        this.saveLoading = false;
                        this.$message('保存成功');
                    }).catch(()=>{
                        this.saveLoading = false;
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

    }
}
</script>
<style lang="stylus" scoped>
.el-select 
    width 100%
.btnBox
    text-align center
    padding-top 40px
    .btn
        width 290px
        margin auto
        background-image $btnBg
        border 0
        background-size 100% 100%
        &:hover
            background-image $btnBg
            background-size 100% 100%
</style>


// WEBPACK FOOTER //
// src/components/my/myInfo/studentInfo.vue